import {
  FilterType,
  buildCustomTemplatesDataTableFilter,
  useCustomTemplatesDataTable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const createdOnFilter = (source: ReturnType<typeof useCustomTemplatesDataTable>) =>
  buildCustomTemplatesDataTableFilter(source, {
    title: i18n.t('performance_process.reviews.datatable.created_on'),
    path: 'createdAt',
    type: FilterType.Date,
    categories: [
      {
        kind: 'DateTimePicker',
        operation: 'between',
        value: [
          dateToString(moment(), 'backend_datetime'),
          dateToString(moment(), 'backend_datetime'),
        ],
      },
    ],
    identifier: 'created_on',
  })

export default createdOnFilter
